<template>
    <div class="maincontainer">
        <div class="maincolumn">
            404
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "error-404",
  components: {},
  setup() {

  },
});
</script>
